module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line"
  }, [_c('v-header', {
    attrs: {
      "name": _vm.name,
      "legendArr": _vm.legendArr,
      "myChart": _vm.myChart
    }
  }), _vm._v(" "), (_vm.myChart._dom) ? _c('v-filter', {
    attrs: {
      "myChart": _vm.myChart
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "main"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-30ee6e5d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/line/line.vue
// module id = 576
// module chunks = 2